import { EditInCell } from "../../Components";

type DecorateEditableColumnsOptions = {
  editIndex: any[];
  dataSource?: any[];
  getDataSource?: () => any[] | undefined;
  getRowId?: (record: any) => any;
  normalizeValue?: (value: any, dataIndex: any, record: any) => any;
  onUpdate: (dataIndex: any, value: any, rowId: any) => void;
};

const getResolvedEditProps = (
  editProps: any,
  cellValue: any,
  record: any,
  rowId: any,
  editIndex: any[],
) => {
  if (typeof editProps === "function") {
    return editProps(cellValue, record, editIndex);
  }

  return {
    ...editProps,
    value: editProps?.value
      ? editProps.value(cellValue, record, rowId, editIndex)
      : undefined,
  };
};

export const decorateEditableColumns = (
  columns: any[] = [],
  {
    editIndex,
    dataSource,
    getDataSource,
    getRowId = (record: any) => record._id,
    normalizeValue = (value: any) => value,
    onUpdate,
  }: DecorateEditableColumnsOptions,
): any[] =>
  Array.isArray(columns)
    ? columns.map((col: any) => {
        if (Array.isArray(col.children) && col.children.length > 0) {
          return {
            ...col,
            children: decorateEditableColumns(col.children, {
              editIndex,
              dataSource,
              getDataSource,
              getRowId,
              normalizeValue,
              onUpdate,
            }),
          };
        }

        if (!col.editType) {
          return { ...col };
        }

        return {
          ...col,
          render: (cellValue: any, record: any) => {
            const rowId = getRowId(record);
            const editProps = getResolvedEditProps(
              col.editProps,
              cellValue,
              record,
              rowId,
              editIndex,
            );

            return EditInCell({
              type: col.editType,
              column: col?.colReturn
                ? col.colReturn(cellValue, record)
                : cellValue,
              index: rowId,
              dataIndex: col.dataIndex,
              editIndex,
              onChange: (value: any) => {
                const nextValue = normalizeValue(value, col.dataIndex, record);
                onUpdate(col.dataIndex, nextValue, rowId);
                editProps?.onChange?.(value, getDataSource?.() ?? dataSource);
              },
              editProps,
            });
          },
        };
      })
    : [];
